'use strict';
import { iosSelectmenuAccessibilityFixes } from '../utilities/utility';
$(function() {
  var images = [];
  $('.product-detail-card-thumbnail-col__img').each(function(index) {
    images.push($(this).attr('src'));
  });

  function savePDF() {
    var url = $('.downloadUrl').text();
    var fileName = url.substring(url.lastIndexOf('/') + 1);
    if (
      navigator.userAgent.match(/msie/i) ||
      navigator.userAgent.match(/trident/i)
    ) {
      var blobObject = new Blob();

      window.navigator.msSaveBlob(blobObject, url);
    } else {
      $('.downloadPDF').attr('href', url);
      $('.downloadPDF').attr('download', fileName);
    }
  }

  $($('.product-detail-card-thumbnail-col__img')[0]).addClass(
    'product-detail-card-thumbnail-col__img--focus'
  );
  $($('.product-detail-card-thumbnail-col__img')[0]).attr(
    'aria-label',
    'image0'
  );
  $($('.product-detail-card__img')[0]).attr('src', images[0]);
  if ($('.product-detail-card-thumbnail-row').length > 0) {
    $($('.product-detail-card__img')[0]).attr('aria-controls', 0);
  } else {
    $($('.product-detail-card__img')[0]).removeAttr('aria-controls');
  }

  function imageToggle(event) {
    if (event.currentTarget.classList.contains('svg-icon_circle_minus_blue')) {
      event.currentTarget.classList.add('svg-icon_circle_plus_blue');
      event.currentTarget.classList.add('svg-icon_circle_plus_blue-dims');
      event.currentTarget.classList.remove('svg-icon_circle_minus_blue');
      event.currentTarget.classList.remove('svg-icon_circle_minus_blue-dims');
    } else {
      event.currentTarget.classList.remove('svg-icon_circle_plus_blue');
      event.currentTarget.classList.remove('svg-icon_circle_plus_blue-dims');
      event.currentTarget.classList.add('svg-icon_circle_minus_blue');
      event.currentTarget.classList.add('svg-icon_circle_minus_blue-dims');
    }
  }

  function moveLeftOrRight(indicator) {
    var currentThumbnailId = $(
      '.product-detail-card-thumbnail-col__img--focus'
    ).attr('id');
    var currentThumbNailNbr = parseInt(
      currentThumbnailId.charAt(currentThumbnailId.length - 1),
      10
    );
    var currentBigImg = parseInt(
      $('.product-detail-card__img').attr('aria-controls'),
      10
    );

    if (
      (currentBigImg < 5 && indicator === 'right') ||
      (currentBigImg > 0 && indicator === 'left')
    ) {
      if (indicator === 'right') {
        currentBigImg += 1;

        if (currentBigImg !== images.length) {
          $('.product-detail-card-thumbnail-col__img').removeClass(
            'product-detail-card-thumbnail-col__img--focus'
          );
          $('.product-carousel-pager-link').removeClass('active');
          $('.product-detail-card-thumbnail-col__img-mobile-js')
            .find($('.product-carousel-pager-link')[currentBigImg])
            .addClass('active');
          if (currentBigImg < 3) {
            $(
              $('.product-detail-card-thumbnail-col__img')[
                currentThumbNailNbr + 1
              ]
            ).addClass('product-detail-card-thumbnail-col__img--focus');
            $('.product-detail-card__img').attr('src', images[currentBigImg]);
            $('.product-detail-card__img').attr('aria-controls', currentBigImg);
          } else {
            $($('.product-detail-card-thumbnail-col__img')[0]).attr(
              'src',
              images[currentBigImg - 2]
            );
            $($('.product-detail-card-thumbnail-col__img')[0]).attr(
              'aria-label',
              'image'.concat(currentBigImg - 2)
            );
            $($('.product-detail-card-thumbnail-col__img')[1]).attr(
              'src',
              images[currentBigImg - 1]
            );
            $($('.product-detail-card-thumbnail-col__img')[1]).attr(
              'aria-label',
              'image'.concat(currentBigImg - 1)
            );
            $($('.product-detail-card-thumbnail-col__img')[2]).attr(
              'src',
              images[currentBigImg]
            );
            $($('.product-detail-card-thumbnail-col__img')[2]).attr(
              'aria-label',
              'image'.concat(currentBigImg)
            );
            $($('.product-detail-card-thumbnail-col__img')[2]).addClass(
              'product-detail-card-thumbnail-col__img--focus'
            );
            $('.product-detail-card__img').attr('src', images[currentBigImg]);
            $('.product-detail-card__img').attr('aria-controls', currentBigImg);
          }
        }
      } else {
        currentBigImg -= 1;
        $('.product-detail-card-thumbnail-col__img').removeClass(
          'product-detail-card-thumbnail-col__img--focus'
        );
        $('.product-carousel-pager-link').removeClass('active');
        $('.product-detail-card-thumbnail-col__img-mobile-js')
          .find($('.product-carousel-pager-link')[currentBigImg])
          .addClass('active');
        if (currentBigImg < 3 && currentThumbNailNbr === 0) {
          $($('.product-detail-card-thumbnail-col__img')[0]).attr(
            'src',
            images[currentBigImg]
          );
          $($('.product-detail-card-thumbnail-col__img')[0]).attr(
            'aria-label',
            'image'.concat(currentBigImg)
          );
          $($('.product-detail-card-thumbnail-col__img')[1]).attr(
            'src',
            images[currentBigImg + 1]
          );
          $($('.product-detail-card-thumbnail-col__img')[1]).attr(
            'aria-label',
            'image'.concat(currentBigImg + 1)
          );
          $($('.product-detail-card-thumbnail-col__img')[2]).attr(
            'src',
            images[currentBigImg + 2]
          );
          $($('.product-detail-card-thumbnail-col__img')[2]).attr(
            'aria-label',
            'image'.concat(currentBigImg + 2)
          );
          $($('.product-detail-card-thumbnail-col__img')[0]).addClass(
            'product-detail-card-thumbnail-col__img--focus'
          );
          $('.product-detail-card__img').attr('src', images[currentBigImg]);
          $('.product-detail-card__img').attr('aria-controls', currentBigImg);
        } else {
          $(
            $('.product-detail-card-thumbnail-col__img')[
              currentThumbNailNbr - 1
            ]
          ).addClass('product-detail-card-thumbnail-col__img--focus');
          $('.product-detail-card__img').attr('src', images[currentBigImg]);
          $('.product-detail-card__img').attr('aria-controls', currentBigImg);
        }
      }
    }
  }

  function decidingDirection(event) {
    if (
      event.currentTarget.className ===
      'product-detail-card-thumbnail-right__icon'
    ) {
      moveLeftOrRight('right');
    } else {
      moveLeftOrRight('left');
    }
  }

  function selectThumbnail() {
    var currentImageLabel = $(this).attr('aria-label');
    var currentImageLabelNbr = parseInt(
      currentImageLabel.charAt(currentImageLabel.length - 1),
      10
    );
    var imgSrc = $(this).attr('src');
    $('.product-detail-card-thumbnail-col__img--focus').removeClass(
      'product-detail-card-thumbnail-col__img--focus'
    );
    $(this).addClass('product-detail-card-thumbnail-col__img--focus');
    $('.product-detail-card__img').attr('src', imgSrc);
    $('.product-detail-card__img').attr('aria-controls', currentImageLabelNbr);
  }

  //Swipe Left / Right
  let initialX = null;
  let initialY = null;

  function startTouch(e) {
    initialX = e.touches[0].clientX;
    initialY = e.touches[0].clientY;
  }

  function moveTouch(e) {
    if (initialX === null) {
      return;
    }

    if (initialY === null) {
      return;
    }

    const currentX = e.touches[0].clientX;
    const currentY = e.touches[0].clientY;

    const diffX = initialX - currentX;
    const diffY = initialY - currentY;

    if (Math.abs(diffX) > Math.abs(diffY)) {
      // sliding horizontally
      if (diffX > 0) {
        // swiped left
        moveLeftOrRight('right');
      } else {
        // swiped right
        moveLeftOrRight('left');
      }
    }

    initialX = null;
    initialY = null;

    e.preventDefault();
  }

  $('#qtydd_md')
    .selectmenu({
      classes: {
        'ui-selectmenu-open': 'pdp-qty__selectmenu'
      },
      open: function() {
        iosSelectmenuAccessibilityFixes($(this));
      },
      close: function() {
        $(this)
          .next('.ui-selectmenu-button')
          .focus();
      }
    })
    .selectmenu('menuWidget')
    .addClass('overflow');
  $('#qtydd_md-button').css('width', $('#qtydd_md').width());
  // Accessibility Fix
  $('#qtydd_md-button')
    .find('.ui-selectmenu-icon')
    .attr('aria-label', 'Dropdown Toggle');
  $(
    '.product-section-desc-label-icon__img, .product-section-features-label-icon__img'
  ).on('click', imageToggle);
  $('.learn-more-label-icon__img').on('click', imageToggle);
  $('.product-detail-card-thumbnail-col__img').on(
    'click focus',
    selectThumbnail
  );
  $(
    '.product-detail-card-thumbnail-right__icon,.product-detail-card-thumbnail-left__icon'
  ).on('click', decidingDirection);
  $('.product-detail-card-thumbnail-col__img-js').on(
    'click focus',
    selectThumbnail
  );
  $('.product-detail-card-img-wrapper-col').on('touchstart', startTouch);
  $('.product-detail-card-img-wrapper-col').on('touchmove', moveTouch);
});

$(document).ready(function() {
  setTimeout(function() {
    ACC.utility.setEllipsis(
      $(
        '.pdp-reference-product .pdp-reference-product-heading .product-heading-text__link'
      )
    );
  }, 100);
  $('.product__list--wrapper #sortOptions1,header #sortOptions1').selectmenu();
  $('#sortOptions1-button').addClass('hidden-xs');
});
